export const isOdysseyEnabled = (container: Window = window) =>
  Boolean(container.FANDOM_ODYSSEY);
